export const Triangle = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <path
        d='M7.55355 6.19153L4.46848 9.2766C4.42593 9.31916 4.39401 9.36525 4.37273 9.4149C4.35146 9.46454 4.34082 9.51774 4.34082 9.57447C4.34082 9.68795 4.37983 9.78724 4.45784 9.87234C4.53585 9.95745 4.63869 10 4.76635 10H11.2344C11.362 10 11.4649 9.95745 11.5429 9.87234C11.6209 9.78724 11.6599 9.68795 11.6599 9.57447C11.6599 9.5461 11.6173 9.44681 11.5322 9.2766L8.44716 6.19153C8.37624 6.12061 8.30532 6.07096 8.2344 6.04259C8.16348 6.01422 8.08546 6.00004 8.00036 6.00004C7.91525 6.00004 7.83724 6.01422 7.76632 6.04259C7.6954 6.07096 7.62447 6.12061 7.55355 6.19153Z'
        fill='currentColor'
      />
    </svg>
  )
}
